var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryExclamatoryIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.046,
    height: 12.046,
    viewBox: "0 0 12.046 12.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Failed",
    transform: "translate(-1423.977 -1311.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3579",
    "data-name": "Group 3579",
    transform: "translate(1424 1312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3573",
    "data-name": "Group 3573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3571",
    "data-name": "Group 3571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1235",
    "data-name": "Rectangle 1235",
    width: 12,
    height: 12,
    fill: "#ffd6d6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert-circle-outline",
    transform: "translate(0.727 0.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M74.546,69.273a5.273,5.273,0,1,0-5.273,5.273A5.274,5.274,0,0,0,74.546,69.273Z",
    transform: "translate(-64 -64)",
    fill: "none",
    stroke: "#e00f0f",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M250.254,160.193l.193,2.918.193-2.918a.118.118,0,0,0-.054-.1.237.237,0,0,0-.141-.042h0a.235.235,0,0,0-.138.043A.118.118,0,0,0,250.254,160.193Z",
    transform: "translate(-245.174 -157.202)",
    fill: "none",
    stroke: "#e00f0f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M236.672,329.255a.672.672,0,1,1,.672-.672A.672.672,0,0,1,236.672,329.255Z",
    transform: "translate(-231.399 -320.811)",
    fill: "#e00f0f"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryExclamatoryIcon);
export default __webpack_public_path__ + "static/media/history-exclamatory-icon.3bc47a8bdee4d247a318881c02f8de05.svg";
export { ForwardRef as ReactComponent };